export default __webpack_public_path__ + "static/media/rocket_anim_102.a4ddb955.png";